import { render, staticRenderFns } from "./bankDetail.vue?vue&type=template&id=3f568336&scoped=true&"
import script from "./bankDetail.vue?vue&type=script&lang=js&"
export * from "./bankDetail.vue?vue&type=script&lang=js&"
import style0 from "./bankDetail.vue?vue&type=style&index=0&id=3f568336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f568336",
  null
  
)

export default component.exports